import { render } from "./BannerBox.vue?vue&type=template&id=0e030c31"
import script from "./BannerBox.vue?vue&type=script&lang=js"
export * from "./BannerBox.vue?vue&type=script&lang=js"

import "./BannerBox.vue?vue&type=style&index=0&id=0e030c31&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__